export function formatGrouped(num, round = true) {
    return new Intl.NumberFormat(undefined, { maximumFractionDigits: round ? 0 : undefined }).format(num);
}
export function formatPercent(num, round = true) {
    const formatted = new Intl.NumberFormat(undefined, { maximumFractionDigits: round ? 0 : undefined }).format(num * 100);
    return `${formatted}%`;
}
//# sourceMappingURL=number.js.map